<!-- 联系我们弹框 -->
<template>
  <el-dialog
    custom-class="ContractUsModal"
    :visible="contractVisible"
    :close-on-press-escape="false"
    :close-on-press-modal="false"
    width="900px"
    :before-close="handleClose"
  >
    <ContractUs :showInModal="true" @close="handleClose"></ContractUs>
  </el-dialog>
</template>

<script>
import ContractUs from "@/components/ContractUs.vue";
export default {
  name: "ContractUsModal",
  components: { ContractUs },
  props: {
    contractVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("update:contractVisible", false);
    },
  },
};
</script>

<style lang="scss">
.ContractUsModal {
  border: none;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 40px;
    .contact-us-container {
      padding: 0;
    }
  }
}
</style>
